/**
 * Stores an ID in localStorage and assigns it to a given store object.
 * @param id - The ID to store.
 * @param storeName - The object to which the stored ID will be assigned.
 * @param key - The localStorage key to use (default is 'id').
 */
export const storeIdToLocalStorage = (id: any, storeName: any, key: string = 'id') => {
    localStorage.removeItem(key);
    localStorage.setItem(key, JSON.stringify(id));
  
    const storedId = localStorage.getItem(key);
    if (storedId) {
      storeName.ID = JSON.parse(storedId);
    }
  };
  